module.exports = __webpack_public_path__ + "static/media/getting-started.cf2953c4.png";